export default "__VITE_ASSET__BQXpgoW1__"